export default function Settings() {
 
    return (
      <div className="settings-page-content">
          <h1>Settings</h1>
      </div>
    );
  }
  